import React, { useEffect, useState } from "react";
import Button from "../../common/Button";
import SearchSelectStore from "../Inventory/SearchSelectedStore";
import SearchSelectDoctor from "../Partners/Doctor/SearchSelectDoctor";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStores,
  integrateDoctor,
} from "../../../redux/Thunk/Store/StoreThunks";
import {
  setDoctorById,
  setSearchDoctor,
} from "../../../redux/Reducer/Doctor/DoctorSlice";
import {
  getAllDoctorsOfStore,
  getDoctorsNotAssigned,
  UnlinkDoctorFromStore,
} from "../../../redux/Thunk/Doctor/DoctorThunks";
import { setStoreById } from "../../../redux/Reducer/Store/StoreSlice";
import CheckedBg from "../../common/icons/CheckedBg";
import Link from "../../common/icons/Link";
import Blink from "../../common/icons/Blink";
import toast from "react-hot-toast";
import Loader from "../../Loader";

const Integration = () => {
  const [isViewdoctoDetails, setIsViewdoctoDetails] = useState(null);
  const [isViewFetchDetails, setISViewFetchDetails] = useState(false);
  const [isViewIntegrateDoctor, setISViewIntegrateDoctor] = useState(false);
  const [doctorIntegrated, setDoctorIntegrated] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState("");

  const {
    doctorAssociatedWithStore: DoctorList,
    doctorById,
    doctors,
  } = useSelector((state) => state?.doctor);
  const { storeById, stores, loading } = useSelector((state) => state?.store);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setStoreById({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchStores());
    dispatch(getDoctorsNotAssigned());
  }, [dispatch]);

  useEffect(() => {
    if (doctorIntegrated) {
      setTimeout(() => {
        setDoctorIntegrated(false);
        dispatch(setDoctorById({}));
      }, 1000);
    }
  }, [doctorIntegrated, dispatch]);
  const handleViewDoctorDetails = (id) => {
    if (isViewdoctoDetails === id) {
      setIsViewdoctoDetails(null);
    } else {
      setIsViewdoctoDetails((prevId) => (prevId === id ? null : id));
    }
  };
  const handletoggleFetchDoctor = () => {
    setISViewFetchDetails(!isViewFetchDetails);
  };

  const handleToggleIntegrateDoctor = () => {
    setISViewIntegrateDoctor(!isViewIntegrateDoctor);
  };

  const handleIntegrateDoctor = async (e) => {
    e.preventDefault();
    const DoctorID = doctorById?.DID;
    const StoreId = storeById?.SID;
    if (DoctorID && StoreId) {
      const data = { SID: StoreId, doctorId: DoctorID };
      try {
        const response = await dispatch(integrateDoctor(data)).unwrap();
        if (response.status === 201 || response.status === 200) {
          dispatch(getAllDoctorsOfStore(StoreId));
          dispatch(getDoctorsNotAssigned());
          setDoctorIntegrated(true);
          dispatch(setSearchDoctor(false));
          setSelectedDoctor("");
          setISViewIntegrateDoctor(false);
          setIsViewdoctoDetails(null);
        }
      } catch (error) {
        console.error("Complete Error Object:", error);
        toast.error(error?.message);
        if (error.response) {
          if (error && error.message) {
            console.error("API Error:", error.message);
          } else {
            console.error("Unexpected Error:", error);
          }
        }
      }
    }
  };
  const handleRemoveDoctor = (id, sid) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to unlink this doctor?"
    );
    if (confirmDelete) {
      const ids = { id, sid };
      dispatch(UnlinkDoctorFromStore(ids));
    }
  };

  return (
    <>
      {loading ? <Loader loading={loading} /> : null}
      <main>
        <div className="flex items-center mb-4 justify-between gap-5"></div>
        <section className="tab-doctor relative">
          <div className="pb-4 flex gap-[10px] justify-between">
            <div className="min-h-[60px] relative rounded-[8px] w-[calc(100%_-_310px)]">
              <SearchSelectStore
                type="integration"
                setISViewIntegrateDoctor={setISViewIntegrateDoctor}
              />
            </div>
            <div className="flex items-center gap-[10px]">
              <div className="bg-primary-50 py-[18px] min-h-[60px] px-[30px] flex items-center relative rounded-[8px] text-[16px] text-secondry-600">
                Doctors
                <span className="pl-5 block font-medium text-black-lose">
                  {DoctorList?.length
                    ? DoctorList?.map((list, index) => list?.doctors?.length)
                    : doctors?.length}
                </span>
              </div>
              <div className="bg-primary-50 py-[18px] min-h-[60px] px-[30px] flex items-center relative rounded-[8px] text-[16px] text-secondry-600">
                Store
                <span className="pl-5 block font-medium text-black-lose">
                  {stores?.length}
                </span>
              </div>
            </div>
          </div>
          {Object.keys(storeById)?.length ? (
            <div className="bg-primary-50 py-3 px-5 rounded-[12px] shadow-[0_5px_10px_rgba(0,0,0,0.09)] mb-3">
              <div className="mb-3">
                <h4 className="text-primary-400 text-[13px] font-medium mb-2">
                  Store Details
                </h4>
              </div>
              <div className="text-[25px] font-medium mb-2 flex gap-2">
                <h2>{storeById?.title}</h2>
              </div>
              <div className="flex gap-2 text-black-lose text-[16px] mb-1">
                <h3>Store ID</h3> : <span>{storeById?.SID}</span>
              </div>
              <div className="flex gap-2 text-black-lose text-[16px] mb-1">
                <h3>Store Address</h3> :{" "}
                <span>
                  {storeById?.address?.areaRoad} &nbsp;{" "}
                  {storeById?.address?.city}
                </span>
              </div>
            </div>
          ) : null}

          <div
            className={`${
              DoctorList?.length > 0
                ? `bg-primary-50 py-3 px-5 rounded-[12px] shadow-[0_5px_10px_rgba(0,0,0,0.09)]`
                : ""
            }`}
          >
            {DoctorList?.length > 0 ? (
              <>
                <h2 className="text-black-lose text-[20px] mb-2">
                  Associated Doctors
                </h2>
                {DoctorList?.length > 0
                  ? DoctorList?.map((list, index) =>
                      list?.doctors?.map((doctor, index) => (
                        <div className="bg-gray-100 px-4 py-2 rounded-[8px] shadow-[0_5px_10px_rgba(0,0,0,0.09)] mb-2">
                          <div className="flex items-center justify-between mb-3">
                            <div>
                              <h2 className="text-[16px] text-black-lose font-medium mb-1">
                                {doctor?.personalInfo?.name} &nbsp;
                                {doctor?.personalInfo?.surname}, {doctor?.DID}
                              </h2>
                              <h3 className="text-[16px] text-secondry-600 whitespace-pre-wrap">
                                {
                                  doctor?.personalInfo
                                    ?.qualificationSpecialisation
                                }
                              </h3>
                            </div>
                            <div>
                              <Button
                                className="h-[40px] w-[40px] bg-primary-50 shadow-[0_5px_8px_rgba(0,0,0,0.09)] flex items-center justify-center rounded-[4px]"
                                onClick={() =>
                                  handleViewDoctorDetails(doctor?.id)
                                }
                                type="button"
                              >
                                <Blink />
                              </Button>
                            </div>
                          </div>
                          {/* --------------doctor details for integratio section start--------------- */}
                          <div
                            className={
                              isViewdoctoDetails === doctor.id ? "" : "hidden"
                            }
                          >
                            <p className="mb-2 text-yellow-500">
                              NOTE: All of the data of the doctor associated
                              with this clinic and store will be erased.
                            </p>
                            <div className="bg-primary-50 rounded-[8px] py-3 px-5 shadow-[inset_0_4px_4px_rgba(0,0,0,0.18)] mb-3">
                              <h2 className="text-black-lose font-medium text-[20px] mb-3">
                                {doctor?.personalInfo?.name} &nbsp;
                                {doctor?.personalInfo?.surname}
                              </h2>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Joining Date
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {new Date(
                                    doctor?.createdAt
                                  ).toLocaleDateString(undefined, {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </p>
                              </div>
                              {/* <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  GSTN
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {}
                                </p>
                              </div> */}
                              {/* <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Registration No.
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  Enter
                                </p>
                              </div> */}
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Qualification/Specialisation
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600 whitespace-pre-wrap">
                                  {
                                    doctor?.personalInfo
                                      ?.qualificationSpecialisation
                                  }
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Experience
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.personalInfo?.experience}
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  About
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.personalInfo?.about1}
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Full Address
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.clinicAddress?.areaRoad} , &nbsp;{" "}
                                  {doctor?.clinicAddress?.premisesName} , &nbsp;{" "}
                                  {doctor?.clinicAddress?.premisesNo} , &nbsp;{" "}
                                  {doctor?.clinicAddress?.floor
                                    ? `${doctor?.clinicAddress?.floor} floor ,`
                                    : ""}{" "}
                                  &nbsp;
                                  <br />
                                  {doctor?.clinicAddress?.city} , &nbsp;
                                  {doctor?.clinicAddress?.state} , &nbsp;
                                  {doctor?.clinicAddress?.pinCode} &nbsp;
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Contact
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.contactNumber}
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Contact 2
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.clinicAddress?.clinicContactNumber}
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Email
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.emailInfo?.doctorEmail}
                                </p>
                              </div>
                              <div className="flex gap-3 mb-2">
                                <h4 className="min-w-[300px] text-[16px] text-primary-400">
                                  Email 2
                                </h4>
                                <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                                  {doctor?.emailInfo?.clinicEmail}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <Link />
                              <p className="text-orange-800">
                                Careful! This action cannot be restored.
                              </p>
                            </div>
                            <div className="flex gap-3 mb-2 pt-3">
                              <Button
                                className="rounded-full flex text-[13px] items-center justify-center text-white bg-primary-600 h-[36px] py-2 px-10 shadow-none outline-none"
                                onClick={() => setIsViewdoctoDetails(null)}
                              >
                                Cancel
                              </Button>
                              <Button
                                className="rounded-full flex text-[13px] items-center justify-center text-white bg-primary-600 h-[36px] py-2 px-10 shadow-none outline-none"
                                onClick={() =>
                                  handleRemoveDoctor(doctor?.DID, doctor?.SID)
                                }
                              >
                                Unlink
                              </Button>
                            </div>
                          </div>
                          {/* --------------doctor details for integratio section end--------------- */}
                        </div>
                      ))
                    )
                  : null}
              </>
            ) : null}
            {Object.keys(storeById)?.length ? (
              <div className="pt-3">
                <Button
                  className="border border-primary-600 h-[36px] text-secondry-600 py-2 px-10 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  type="button"
                  onClick={() => handleToggleIntegrateDoctor()}
                >
                  <Link /> Integrate Doctor
                </Button>
              </div>
            ) : null}
          </div>

          {/* ----------integrate doctor section start---------- */}
          <div
            className={
              isViewIntegrateDoctor
                ? "bg-primary-50 py-3 px-5 rounded-[12px] shadow-[0_5px_10px_rgba(0,0,0,0.09)]"
                : "hidden"
            }
          >
            <h2 className="text-black-lose text-[25px] mb-2">
              Integrate Doctor
            </h2>
            <SearchSelectDoctor
              doctors={null}
              formik={null}
              type="integration"
              selectedDoctor={selectedDoctor}
              setSelectedDoctor={setSelectedDoctor}
            />
            {Object.keys(doctorById)?.length > 0 ? (
              <div className="pt-3">
                <Button
                  className="border border-primary-600 h-[36px] text-secondry-600 py-2 px-10 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  onClick={() => handletoggleFetchDoctor()}
                  type="button"
                >
                  <Link /> Fetch Details
                </Button>
              </div>
            ) : null}

            {/* ----------------fetch details section start------------------------*/}
            <div
              className={
                isViewFetchDetails && Object.keys(doctorById)?.length > 0
                  ? "pt-4"
                  : "hidden"
              }
            >
              <div className="bg-primary-50 rounded-[8px] py-3 px-5 shadow-[inset_0_4px_4px_rgba(0,0,0,0.18)] mb-3">
                <p className="text-gray-600 py-3">Fetched details</p>
                <h2 className="text-black-lose font-medium text-[20px] mb-3">
                  {doctorById?.personalInfo?.name} &nbsp;
                  {doctorById?.personalInfo?.surname}
                </h2>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Joining Date
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {new Date(doctorById?.createdAt).toLocaleDateString(
                      undefined,
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    GSTN
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.compliance?.gstNumber}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Registration No.
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.compliance?.registrationNumber}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Qualification/Specialisation
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600 whitespace-pre-wrap">
                    {doctorById?.personalInfo?.qualificationSpecialisation}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Experience
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.personalInfo?.experience}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    About
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.personalInfo?.about1} <br />{" "}
                    {doctorById?.personalInfo?.about2}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Full Address
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.clinicAddress?.areaRoad} , &nbsp;{" "}
                    {doctorById?.clinicAddress?.premisesName} , &nbsp;{" "}
                    {doctorById?.clinicAddress?.premisesNo} , &nbsp;{" "}
                    {doctorById?.clinicAddress?.floor
                      ? `${doctorById?.clinicAddress?.floor} floor ,`
                      : ""}{" "}
                    &nbsp;
                    <br />
                    {doctorById?.clinicAddress?.city} , &nbsp;
                    {doctorById?.clinicAddress?.state} , &nbsp;
                    {doctorById?.clinicAddress?.pinCode} &nbsp;
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Contact
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.contactNumber}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Contact 2
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.clinicAddress?.clinicContactNumber}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Email
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.emailInfo?.doctorEmail}
                  </p>
                </div>
                <div className="flex gap-3 mb-2">
                  <h4 className="min-w-[300px] text-[16px] text-primary-400">
                    Email 2
                  </h4>
                  <p className="w-[calc(100%_-_300px)] pl-4 text-[16px] font-medium text-secondry-600">
                    {doctorById?.emailInfo?.clinicEmail}
                  </p>
                </div>
              </div>
            </div>
            {/* ----------------fetch details section end------------------------*/}
            <div className="pt-3 flex items-center gap-[15px]">
              <Button
                className="rounded-full flex text-[13px] items-center justify-center text-white bg-primary-600 h-[36px] py-2 px-10 shadow-none outline-none"
                onClick={(e) => handleIntegrateDoctor(e)}
                type="button"
              >
                Integrate to store
              </Button>
              <div
                className={
                  doctorIntegrated
                    ? "w-[24px] h-[24px] opacity-100"
                    : "opacity-0"
                }
              >
                <CheckedBg fill="#00C732" />
              </div>
            </div>
          </div>
          {/* ----------integrate doctor section end---------- */}
        </section>
      </main>
    </>
  );
};

export default Integration;
